export type UserSession = {
	avatar?: string;
	email?: string;
	id: string;
	name: string;
	nickname?: string;
	phone?: string;
	token: string;
	username?: string;
};

export type SessionUserLike = {
	access_token?: string | null;
	avatar?: string | null;
	email?: string | null;
	headimgurl?: string | null;
	id?: string | null;
	id_token?: string | null;
	name?: string | null;
	nickname?: string | null;
	phone_number?: string | null;
	phone?: string | null;
	photo?: string | null;
	picture?: string | null;
	preferred_username?: string | null;
	sub?: string | null;
	token?: string | null;
	username?: string | null;
};

const PRIVATE_DISPLAY_NAME_PATTERN = /^(\+?\d[\d\s-]{6,}\d)$/;
const trimValue = (value?: string | null) => value?.trim() || "";
const normalizeAvatarUrl = (value?: string | null) => {
	const url = trimValue(value);
	if (!url) return "";
	if (url.startsWith("//")) return `https:${url}`;
	if (url.startsWith("http://")) return url.replace(/^http:/u, "https:");
	return url;
};
const maskPrivateDisplayName = (value: string) => {
	if (PRIVATE_DISPLAY_NAME_PATTERN.test(value)) {
		const digits = value.replace(/\D/gu, "");
		if (digits.length >= 8) return `${digits.slice(0, 3)}****${digits.slice(-4)}`;
	}
	if (value.includes("@")) {
		const [name] = value.split("@");
		return name || value;
	}
	return value;
};
const SESSION_KEY = "benyi_session_v1";
const TOKEN_KEY = "token";

export const toUserSession = (
	user: SessionUserLike | null | undefined,
	token?: string | null,
): UserSession | null => {
	const id = user?.id || user?.sub;
	const sessionToken = token || user?.token || user?.access_token || user?.id_token;
	if (!id || !sessionToken) return null;
	const username = trimValue(user?.username || user?.preferred_username);
	const nickname = trimValue(user?.nickname);
	const rawName = trimValue(user?.name);
	const phone = trimValue(user?.phone_number || user?.phone);
	const email = trimValue(user?.email);
	const displayName = [nickname, rawName, username, phone, email]
		.map((item) => (item ? maskPrivateDisplayName(item) : ""))
		.find(Boolean);
	const avatar = normalizeAvatarUrl(user.avatar || user.picture || user.photo || user.headimgurl);

	return {
		avatar: avatar || undefined,
		email: email || undefined,
		id,
		name: displayName || "练习者",
		nickname: nickname || undefined,
		phone: phone || undefined,
		token: sessionToken,
		username: username || undefined,
	};
};

export const saveUserSession = (session: UserSession) => {
	localStorage.setItem(TOKEN_KEY, session.token);
	localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const loadUserSession = (): UserSession | null => {
	const cached = localStorage.getItem(SESSION_KEY);
	if (!cached) return null;
	try {
		return JSON.parse(cached) as UserSession;
	} catch {
		localStorage.removeItem(SESSION_KEY);
		return null;
	}
};

export const clearUserSession = () => {
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(SESSION_KEY);
};
